module.exports = __webpack_public_path__ + "img/vertical-traffic-light.e314c92c.png";